import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxImageCompressService } from 'ngx-image-compress';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NgxSpinnerService } from "ngx-spinner";
import * as CryptoJS from 'crypto-js';
import { Clipboard } from '@angular/cdk/clipboard';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import {
  ScannerQRCodeConfig,
  ScannerQRCodeResult,
  NgxScannerQrcodeService,
  NgxScannerQrcodeComponent,
  ScannerQRCodeSelectedFiles,
} from 'ngx-scanner-qrcode';
// import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { MarketplacePageComponent } from '../marketplace/marketplace.component';
import { QRCodeElementType } from 'angularx-qrcode';

@Component({
  selector: 'app-customer-shopping',
  templateUrl: './customer-shopping.component.html',
  styleUrls: ['./customer-shopping.component.scss']
})
export class CustomerShoppingComponent implements OnInit {

  @ViewChild('marketplace') marketplaceProfileSection: MarketplacePageComponent;

  private modalRef: any;
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  model: NgbDateStruct;
  public elementType: QRCodeElementType = "url";

  disabledDates: NgbDateStruct[] = [];





  today: Date = new Date();
  time: NgbTimeStruct = {
    hour: 10,
    minute: 0,
    second: 0,
  };
  meridian = true;
  date: { year: number; month: number };
  formattedDateTime: string;


  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };
  private eventTimeout: any;

  QrCodeValue = '';
  categories: any;
  selectedCatId: any;
  subcategories: any;
  selectedsubCatId: any;
  food_listing_response: any;

  edit_product_id: any;
  food_details: any;
  food_image_1: any = "";
  food_image_2: any = "";
  food_image_3: any = "";
  food_image_4: any = "";
  food_icon_1: any = "";
  food_icon_2: any = "";
  food_icon_3: any = "";
  food_icon_4: any = "";
  editprodForm: FormGroup;
  specsId: any = 0;
  qty: any = "";
  productListId: any = 0;
  cart_listing_response: any;
  cart_total: any;
  cart_total_response_length: any;
  confirm_payment_form: FormGroup;
  shop_signin_form: FormGroup;
  submitted = false;
  order_history_response: any;
  order_history_response_length: any;
  get_selected_products_listing: any;
  selectedSubCatIndex: any = 0;
  filteredProducts: any;
  searchText: string = '';
  global_food_id: any;
  selectedPaymentMethod: any;
  client_id: string = "";
  get_selected_products_listing_length: any;
  filteredProductsLength: number;
  food_description: any;
  isLogin: any = 0;
  encrypted_client_id: string = "";
  appUserId: any = 0;
  referralLink: string = "";
  enc_app_user_id: string = "";
  url_type: string = "";
  visitorId: string = "";
  screenshot_image_show: number;
  screenshot_image_url: any;
  imagePath: any;
  selectedImage: File;
  isConfirmEnable: number = 0;
  shop_logo: any;
  shop_banner: any;
  shop_description: any;
  shop_qr_image: any;
  qr_text: any;
  spec_id_array: any = [];
  rating_array: any = [1, 2, 3, 4, 5]
  reviews_list: any = [];
  baseUrlImgae = environment.ImageUrl;
  appShopId: number;
  activateVoucherList: any;
  food_image_active: any;
  errorChatURL: boolean = false;
  shop_template = 'default';

  public config: ScannerQRCodeConfig = {
    constraints: {
      video: {
        width: this.window.innerWidth
      },
    },
    canvasStyles: [
      { /* layer */
        lineWidth: 1,
        fillStyle: '#00950685',
        strokeStyle: '#00950685',
      },
      { /* text */
        font: '17px serif',
        fillStyle: '#ff0000',
        strokeStyle: '#ff0000',
      }
    ],
  };
  public qrCodeResult: ScannerQRCodeSelectedFiles[] = [];
  public qrCodeResult2: ScannerQRCodeSelectedFiles[] = [];

  @ViewChild('action') action!: NgxScannerQrcodeComponent;
  public percentage = 80;
  public quality = 100;
  selectedVoucher: any;
  imgUrl: string;
  w_phone_number: any;
  currentDate: string;
  bookingDate: any;
  productId: any;
  allowBooking: boolean;
  userProductBooking: any;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private imageCompress: NgxImageCompressService,
    private modalService: NgbModal,
    private modalService2: NgbModal,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private clipboard: Clipboard,
    config: NgbCarouselConfig,
    private calendar: NgbCalendar,
    private qrcode: NgxScannerQrcodeService,
    @Inject("WINDOW") private window: any,
  ) {
    this.configSlider(config)

    this.route.params.subscribe((res: any) => {
      if (Object.keys(res).length === 0) {
        return;
      }
      if (res.id) {
        // const encStr = CryptoJS.AES.encrypt('normal_47', 'shop-web-links').toString();
        if (res.id) {
          const bytes = CryptoJS.AES.decrypt(res.id.trim(), 'shop-web-links');
          const originalText = bytes.toString(CryptoJS.enc.Utf8);
          const splitText = originalText.split("_");
          if (splitText.length == 2 && splitText.includes("normal")) {

            this.url_type = "normal";
            this.client_id = splitText[1];
            this.encrypted_client_id = encodeURIComponent(res.id.trim());
          } else if (splitText.length == 3 && splitText.includes("referral")) {

            this.url_type = "referral";
            this.client_id = splitText[1];
            this.enc_app_user_id = splitText[2];
            this.encrypted_client_id = encodeURIComponent(res.id.trim());
          } else {
            this.local.removeAdminData();
            this.local.removeData();
            return this.router.navigate(['/']);
          }

        }
      }
    });

    const fpPromise = FingerprintJS.load().then(async (fp) => {
      const result = await fp.get();
      this.visitorId = result.visitorId;
    }).catch(async (error) => {
    }).finally(() => {
    });
    this.model = this.calendar.getToday();

    this.currentDate = this.getCurrentDateTime();
  }

  // customOptions: OwlOptions = {
  //   navText: [ '<i class="fa-chevron-left"></i>', '<i class="fa-chevron-right></i>"' ]
  //  }

  customOptions: OwlOptions = {
    // loop: true,
    // mouseDrag: true,
    // touchDrag: true,
    // pullDrag: true,
    // dots: true,
    // autoplay: false,
    // navSpeed: 700,

    loop: false,
    // mouseDrag: false,
    // touchDrag: false,
    // pullDrag: false ,
    dots: true,
    nav: true,
    navSpeed: 700,
    smartSpeed: 4500,
    slideTransition: 'linear',
    items: 5,
    responsive: {
      0: {
        items: 2
      },
      400: {
        items: 3
      },
      840: {
        items: 4
      },
      940: {
        items: 5
      }
    },

  }

  customOptions2: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: false,
    navSpeed: 500,
    smartSpeed: 1500,
    slideTransition: 'linear',
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 3
      },
      1000: {
        items: 5
      }
    },
  }

  public screenWidth: any = 0;

  ngOnInit(): void {
    // this.initWebCamConfig()
    this.imgUrl = environment.ImageUrl

    this.screenWidth = this.window.innerWidth;

    const getUser = this.local.getUser();
    if (getUser) {
      this.appUserId = getUser.id;
    }

    (getUser) ? this.isLogin = 1 : 0;

    this.getMobile()

    this.getShopProfileData();

    this.getAllCategories();

    // this.cart_listing();

    // this.order_history();

    this.getProductsForSlider();

    this.editprodForm = this.fb.group({
      name: ["", [Validators.required]],
      descp: ["", [Validators.required]],
      memPrice: [""],
      nonMemPrice: ["", [Validators.required]],
      qty: ["", [Validators.required]],
      qtyName1: ["", [Validators.required]],
      qtyPrice1: ["", [Validators.required]],
      qtyName2: [""],
      qtyPrice2: [""],
      qtyName3: [""],
      qtyPrice3: [""],
      qtyName4: [""],
      qtyPrice4: [""],
      image1: [""],
      image2: [""],
      image3: [""],
      icon1: [""],
      icon2: [""],
      icon3: [""],
    });

    this.confirm_payment_form = this.fb.group({
      name: ["", [Validators.required]],
      unit: ["", [Validators.required]],
      address: ["", [Validators.required]],
      postalCode: ["", [Validators.required]],
    });

    this.selectedPaymentMethod = '2';

    if (this.client_id) {
      this.getAllSliderBanners(this.client_id);
    }
  }
  get_all_product_banner_response: any;
  getAllSliderBanners(id) {
    this.auth.get_all_product_banner(id).subscribe((response: any) => {
      this.get_all_product_banner_response = response.body;
    }, (e) => {
      this.toastr.error(e.error.message);
    });
  }

  get confirmPaymentErr() { return this.confirm_payment_form.controls; }

  get editproduct() { return this.editprodForm.controls; }

  get shopSigninV() { return this.shop_signin_form.controls; }

  getShopProfileData() {
    const clientId = this.client_id;
    this.auth.get_shop_profile_data_without_login(clientId).subscribe((response: any) => {
      this.shop_logo = response.body.shop_logo;
      this.shop_banner = response.body.shop_banner;
      this.shop_description = response.body.shop_description;
      this.shop_qr_image = response.body.shop_qr_image;
      this.qr_text = response.body.qr_text;
      if (localStorage.getItem('shopTemplate')) {
        this.shop_template = localStorage.getItem('shopTemplate');
        localStorage.setItem('shopTemplate', this.shop_template);
      } else {
        localStorage.setItem('shopTemplate', 'default');
        this.shop_template = localStorage.getItem('shopTemplate');
      }
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }

      if (e.error.status == 401 || e.status == 401) {
        this.isLogin = 0;
        this.local.logout();
        this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      }
    })
  }

  getProductsForSlider() {
    const clientId = this.client_id;
    this.auth.get_selected_products(clientId).subscribe((response: any) => {
      this.get_selected_products_listing = response.body;
      this.get_selected_products_listing_length = response.body.length;
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }

      if (e.error.status == 401 || e.status == 401) {
        this.isLogin = 0;
        this.local.logout();
        this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      }
    })
  }

  changeShowImageProduct(image: string) {
    this.food_image_active = image
  }
  open_screenshot_upload_popup(modal) {
    this.submitted = true;
    if (this.confirm_payment_form.invalid) {
      return;
    }
    this.getShopProfileData();
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'screenshot_pop' });
  }

  onImageSelected(files, event: any) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.screenshot_image_url = event.target.result;
        this.screenshot_image_show = 1;
      }
      reader.readAsDataURL(event.target.files[0]);
    }

    this.imagePath = files;
    this.selectedImage = <File>files[0];
    this.isConfirmEnable = 1;
  }

  confirm_payment_submit() {
    this.submitted = true;
    if (this.confirm_payment_form.invalid) {
      return;
    }

    this.spinner.show();

    let data: any = { 'name': this.confirmPaymentErr.name.value, 'unit': this.confirmPaymentErr.unit.value, 'address': this.confirmPaymentErr.address.value, 'postalCode': this.confirmPaymentErr.postalCode.value, 'paymentMethod': this.selectedPaymentMethod, 'client_id': this.encrypted_client_id, 'screenshot': this.selectedImage };

    let formData = new FormData();
    formData.append("name", data.name);
    formData.append("unit", data.unit);
    formData.append("address", data.address);
    formData.append("postalCode", data.postalCode);
    formData.append("paymentMethod", data.paymentMethod);
    formData.append("client_id", data.client_id);
    formData.append("screenshot", data.screenshot);

    if (this.isLogin == 1) {
      this.auth.confirm_payment(formData).subscribe((response: any) => {
        this.toastr.success(response.message);
        this.confirm_payment_form.reset();
        this.submitted = false;
        this.isConfirmEnable = 0;
        this.screenshot_image_show = 0;
        this.modalService.dismissAll();
        this.cart_listing();
        this.order_history();
        this.getActiveVouchers()
        this.spec_id_array = []
        this.spinner.hide();
      }, (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }

        if (e.error.status == 401 || e.status == 401) {
          this.isLogin = 0;
          this.local.logout();
          this.router.navigate([`/mobile/${this.encrypted_client_id}`])
        }
      });
    } else {
      data = { ...data, 'visitorId': this.visitorId };
      formData.append("visitorId", data.visitorId);
      this.auth.confirm_payment_without_login(formData).subscribe((response: any) => {
        this.toastr.success(response.message);
        this.confirm_payment_form.reset();
        this.submitted = false;
        this.isConfirmEnable = 0;
        this.screenshot_image_show = 0;
        this.modalService.dismissAll();
        this.cart_listing();
        this.getActiveVouchers()
        this.spinner.hide();
      }, (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }

        if (e.error.status == 401 || e.status == 401) {
          this.isLogin = 0;
          this.local.logout();
          this.router.navigate([`/mobile/${this.encrypted_client_id}`])
        }
      });
    }

  }

  getAllCategories() {
    this.auth.getFoodCategoriesCustomer(this.encrypted_client_id).subscribe((response: any) => {
      const cats = response.body.map(data => {
        return data;
      });
      this.categories = cats;

      // this.categories.unshift({
      //   id: '',
      //   name: 'ALL'
      // });

      this.selectedCatId = this.categories[0].id;
      this.getAllSubCategories();
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }

      if (e.error.status == 401 || e.status == 401) {
        this.isLogin = 0;
        this.local.logout();
        this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      }
    })
  }

  getAllSubCategories() {

    const formData = new FormData();

    formData.append('categoryId', this.selectedCatId);

    this.auth.getFoodSubCategories(formData).subscribe((response: any) => {
      this.subcategories = response.body;

      if (this.subcategories.length == 0) {
        this.selectedSubCatIndex = 0;
      }

      this.subcategories.unshift({
        id: '',
        name: 'PRODUCTS'
      });

      if (this.subcategories.length > 0) {

        if (this.subcategories.length - 1 >= this.selectedSubCatIndex) {
          this.selectedsubCatId = this.subcategories[this.selectedSubCatIndex].id;
          this.getProductList(this.selectedsubCatId, this.selectedSubCatIndex);
        } else {
          this.selectedsubCatId = this.subcategories[this.subcategories.length - 1].id;
          this.getProductList(this.selectedsubCatId, this.selectedSubCatIndex);
        }

      } else {
        this.filteredProducts = [];
      }
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }

      if (e.error.status == 401 || e.status == 401) {
        this.isLogin = 0;
        this.local.logout();
        this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      }
    })
  }

  public onEvent(e: ScannerQRCodeResult[], action?: any): void {
    clearTimeout(this.eventTimeout);
    this.modalDismissAll();

    this.eventTimeout = setTimeout(() => {
      const qrData = e[0]?.value;

      if (qrData) {
        const shopId = qrData.split('=')[1];
        const payload = {
          shopId: shopId,
          userId: this.appUserId,
          voucherId: this.selectedVoucher.id,
          points: this.selectedVoucher.points_required
        };

        this.auth.redeemVoucher(payload).subscribe((res) => {
          this.toastr.success('Voucher redeem completed');
          this.getActiveVouchers();
        });
      } else {
        this.toastr.error('Error reading code');
      }
    }, 500);
  }

  public handle(action: any, fn: string): void {


    const playDeviceFacingBack = (devices: any[]) => {
      // front camera or back camera check here!
      const device = devices.find(f => (/back|rear|environment/gi.test(f.label))); // Default Back Facing Camera
      action.playDevice(device ? device.deviceId : devices[0].deviceId);
    }

    if (fn === 'start') {
      action[fn](playDeviceFacingBack).subscribe((r: any) => console.log(fn, r), alert);
    } else {
      action[fn]().subscribe((r: any) => console.log(fn, r), alert);
    }

  }

  getProductList(subCatId, tabIndex) {
    this.selectedSubCatIndex = tabIndex;
    const formDataFoodListing = new FormData();
    formDataFoodListing.append('categoryId', this.selectedCatId)
    formDataFoodListing.append('subCategoryId', subCatId)
    formDataFoodListing.append('clientId', this.encrypted_client_id);

    this.auth.food_listing_customer(formDataFoodListing).subscribe((response: any) => {
      let foods = [];
      if (this.screenWidth < 768) {
        foods = this.chunkArray(response.body, 2);
      } else if (this.screenWidth >= 768 && this.screenWidth < 992) {
        foods = this.chunkArray(response.body, 3);
      } else if (this.screenWidth >= 992 && this.screenWidth < 1200) {
        foods = this.chunkArray(response.body, 4);
      } else {
        foods = this.chunkArray(response.body, 5);
      }
      this.appShopId = response.body[0].adminId
      if (this.appShopId) {
        this.getActiveVouchers()
      }
      // this.food_listing_response = foods;
      this.filteredProducts = foods;
      this.filteredProductsLength = foods.length;
      // this.search();

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }

      if (e.error.status == 401 || e.status == 401) {
        this.isLogin = 0;
        this.local.logout();
        this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      }
    })
  }

  chunkArray(array, chunkSize) {
    var resultArray = [];
    for (var i = 0; i < array.length; i += chunkSize) {
      var chunk = array.slice(i, i + chunkSize);
      resultArray.push(chunk);
    }
    return resultArray;
  }


  redirectLink(url: string) {
    this.errorChatURL = false

    if (url != '' && url != null)
      this.window.open(url, '_blank');
    else
      this.errorChatURL = true
  }

  tabChange(item) {
    this.searchText = '';
    this.selectedCatId = item.id;
    this.getAllSubCategories();
  }

  subCatTabChange(item) {
    this.searchText = '';
    this.selectedsubCatId = item.id;
  }

  openCartPopup(e: any, modal) {
    e.preventDefault()
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'modal_dialog_pad' });
    this.cart_listing();
  }

  openOrderHistoryPopup(modal) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'modal_dialog_pad' });
    this.order_history();
  }

  editProductModal(modal, food_obj): void {
    this.marketplaceProfileSection.enableMemberShop = true;
    this.marketplaceProfileSection.viewProduct(food_obj,);
    // this.spec_id_array = [];
    // this.modalService.dismissAll();
    // this.disabledDates = []
    // this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'product_detail_popup' });

    // this.edit_product_id = food_id;

    // let formData = new FormData();
    // formData.append('foodId', food_id);
    // this.getProductReviews(food_id)
    // this.auth.get_food_details(formData).subscribe((response: any) => {
    //   this.food_details = response.body;
    //   this.disabledDates = JSON.parse(this.food_details.holidays);

    //   if (this.food_details?.seller_info && this.food_details?.seller_info != "null" && this.food_details?.seller_info != null)
    //     document.getElementById("sellerInfoText").innerHTML = this.food_details.seller_info?.replace(/\n/g, '<br>').replace('<b>', '<br style="font-weight: 800">')
    //   else
    //     document.getElementById("sellerInfoText").innerHTML = `
    //       <b> Seller Info </b></br>
    //       Information is not provided. Please do contact Seller via other methods. 
    //       </br></br>
    //       <b> Delivery </b></br>
    //       Delivery options are not specified.
    //     `

    //   this.food_image_1 = (this.food_details.foodImages.find(o => o.imageAccessor === 'image1') == undefined) ? '' : this.food_details.foodImages.find(o => o.imageAccessor === 'image1').image;
    //   this.food_image_active = this.food_image_1;
    //   this.food_image_2 = (this.food_details.foodImages.find(o => o.imageAccessor === 'image2') == undefined) ? '' : this.food_details.foodImages.find(o => o.imageAccessor === 'image2').image;
    //   this.food_image_3 = (this.food_details.foodImages.find(o => o.imageAccessor === 'image3') == undefined) ? '' : this.food_details.foodImages.find(o => o.imageAccessor === 'image3').image;
    //   this.food_image_4 = (this.food_details.foodImages.find(o => o.imageAccessor === 'image4') == undefined) ? '' : this.food_details.foodImages.find(o => o.imageAccessor === 'image4').image;
    //   this.food_icon_1 = (this.food_details.foodImages.find(o => o.imageAccessor === 'icon1') == undefined) ? '' : this.food_details.foodImages.find(o => o.imageAccessor === 'icon1').image;
    //   this.food_icon_2 = (this.food_details.foodImages.find(o => o.imageAccessor === 'icon2') == undefined) ? '' : this.food_details.foodImages.find(o => o.imageAccessor === 'icon2').image;
    //   this.food_icon_3 = (this.food_details.foodImages.find(o => o.imageAccessor === 'icon3') == undefined) ? '' : this.food_details.foodImages.find(o => o.imageAccessor === 'icon3').image;
    //   this.food_icon_4 = (this.food_details.foodImages.find(o => o.imageAccessor === 'icon4') == undefined) ? '' : this.food_details.foodImages.find(o => o.imageAccessor === 'icon4').image;
    //   this.food_description = this.food_details.description;
    //   this.productId = food_id
    //   this.allowBooking = this.food_details.dateCheckBox
    //   this.getBookingTime()

    // }, (e) => {
    //   if (e.status == 400) {
    //     this.toastr.error(e.error.message);
    //   }

    //   if (e.error.status == 401 || e.status == 401) {
    //     this.isLogin = 0;
    //     this.local.logout();
    //     this.router.navigate([`/mobile/${this.encrypted_client_id}`])
    //   }
    // });
  }

  @ViewChild('bookingModal') bookingModal: any;
  openBookingModal() {
    // this.modalDismissAll() 
    this.modalRef = this.modalService2.open(this.bookingModal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'Qr-scanner-modal' });
  }

  add_to_cart(e: any, food_id) {
    e.preventDefault()
    this.global_food_id = food_id;


    if (this.spec_id_array.length == 0) {
      return this.toastr.warning("Please select atleast one product variant.");
    }

    if (this.global_food_id != this.productListId) {
      this.toastr.error('Please select atleast one product variant.');
      return;
    }

    let formData = new FormData();
    formData.append('foodId', food_id);
    formData.append('foodSpecId', this.spec_id_array.join(","));
    formData.append('quantity', this.qty);
    formData.append('client_id', this.encrypted_client_id);

    if (this.isLogin == 1) {
      this.auth.add_to_cart(formData).subscribe((response: any) => {
        // this.spec_id_array = [];
        this.toastr.success(response.message);
        this.cart_listing();
      }, (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
        if (e.error.status == 401 || e.status == 401) {
          this.isLogin = 0;
          this.local.logout();
          this.router.navigate([`/mobile/${this.encrypted_client_id}`])
        }
      });
    } else {
      this.toastr.error("Please Login First!")
      // formData.append("visitorId", this.visitorId);
      // this.auth.add_to_cart_without_login(formData).subscribe((response: any) => {
      //   // this.spec_id_array = [];
      //   this.toastr.success(response.message);
      //   this.cart_listing();
      // }, (e) => {
      //   if (e.status == 400) {
      //     this.toastr.error(e.error.message);
      //   }
      //   if (e.error.status == 401 || e.status == 401) {
      //     this.isLogin = 0;
      //     this.local.logout();
      //     this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      //   }
      // });
    }
  }

  cart_listing() {
    if (this.isLogin == 1) {
      this.auth.cart_listing(this.client_id, this.visitorId).subscribe((response: any) => {

        this.cart_listing_response = response.body.cart;
        this.cart_total = response.body.total;
        this.cart_total_response_length = response.body.cart.length;

      }, (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }

        if (e.error.status == 401 || e.status == 401) {
          this.isLogin = 0;
          this.local.logout();
          this.router.navigate([`/mobile/${this.encrypted_client_id}`])
        }
      });
    } else {
      this.toastr.error("Please Login First!")
      // this.auth.cart_listing_without_login(this.client_id, this.visitorId).subscribe((response: any) => {
      //   this.cart_listing_response = response.body.cart;
      //   this.cart_total = response.body.total;
      //   this.cart_total_response_length = response.body.cart.length;
      // }, (e) => {
      //   if (e.status == 400) {
      //     this.toastr.error(e.error.message);
      //   }

      //   if (e.error.status == 401 || e.status == 401) {
      //     this.isLogin = 0;
      //     this.local.logout();
      //     this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      //   }
      // });
    }
  }

  inc_dec_qty(cart_id, type) {
    this.spinner.show();
    let formData = new FormData();
    formData.append('cartId', cart_id);
    formData.append('type', type);

    if (this.isLogin == 1) {
      this.auth.inc_dec_qty(formData).subscribe((response: any) => {
        this.toastr.success(response.message);
        this.cart_listing();
        this.spinner.hide();
      }, (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }

        if (e.error.status == 401 || e.status == 401) {
          this.isLogin = 0;
          this.local.logout();
          this.router.navigate([`/mobile/${this.encrypted_client_id}`])
        }

        this.spinner.hide();
      });
    } else {
      this.toastr.error("Please Login First!")
      // formData.append("visitorId", this.visitorId);
      // this.auth.inc_dec_qty_without_login(formData).subscribe((response: any) => {
      //   this.toastr.success(response.message);
      //   this.cart_listing();
      //   this.spinner.hide();
      // }, (e) => {
      //   if (e.status == 400) {
      //     this.toastr.error(e.error.message);
      //   }

      //   if (e.error.status == 401 || e.status == 401) {
      //     this.isLogin = 0;
      //     this.local.logout();
      //     this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      //   }

      //   this.spinner.hide();
      // });
    }
  }

  selectPaymentMethod(type) {
    this.selectedPaymentMethod = type;
  }

  delete_cart_item(cart_id) {

    let formData = new FormData();
    formData.append('cartId', cart_id);

    if (this.isLogin == 1) {
      this.auth.delete_cart_item(formData).subscribe((response: any) => {
        this.toastr.success(response.message);
        this.cart_listing();
      }, (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }

        if (e.error.status == 401 || e.status == 401) {
          this.isLogin = 0;
          this.local.logout();
          this.router.navigate([`/mobile/${this.encrypted_client_id}`])
        }
      });
    } else {
      this.toastr.error("Please Login First!")
      // this.auth.delete_cart_item_without_login(formData).subscribe((response: any) => {
      //   this.toastr.success(response.message);
      //   this.cart_listing();
      // }, (e) => {
      //   if (e.status == 400) {
      //     this.toastr.error(e.error.message);
      //   }

      //   if (e.error.status == 401 || e.status == 401) {
      //     this.isLogin = 0;
      //     this.local.logout();
      //     this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      //   }
      // });
    }
  }

  order_history() {
    this.auth.order_history(this.client_id).subscribe((response: any) => {
      this.order_history_response = response.body;
      this.order_history_response_length = response.body.length;

    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }

      if (e.error.status == 401 || e.status == 401) {
        this.isLogin = 0;
        this.local.logout();
        this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      }
    })
  }

  confirmPaymentModal(modal) {
    this.modalService.dismissAll();

    this.modalRef = this.modalService.open(modal, { size: 'xl', ariaLabelledBy: 'modal-basic-title', windowClass: 'modal_dialog_pad' });
    if (this.isLogin == 1) {
      const { phoneNumber } = this.local.getUser();
      this.confirm_payment_form.patchValue({
        unit: phoneNumber
      });
    }
  }

  cancel_confirm_payment_button(modal) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, { size: 'lg', ariaLabelledBy: 'modal-basic-title', windowClass: 'modal_dialog_pad' });
  }

  modalDismissAll() {
    this.modalService.dismissAll();
  }

  modal2DismissAll() {
    this.modalService2.dismissAll();
  }

  getFoodSpecs(specsId, productListId, isChecked) {
    if (this.productListId == 0) {
      this.spec_id_array.push(specsId);
    } else {
      if (this.productListId == productListId) {
        const isChecked = this.spec_id_array.filter((row: any) => row == specsId)
        if (isChecked.length < 1) {
          this.spec_id_array = [(specsId)];
        } else {
          const index = this.spec_id_array.indexOf(specsId);
          if (index > -1) {
            this.spec_id_array.splice(index, 1);
          }
        }
      } else {
        this.spec_id_array = [];
        this.spec_id_array.push(specsId);
      }
    }
    this.specsId = this.spec_id_array.join(",");
    this.productListId = productListId;
  }

  getQty(qty, productListId) {
    this.qty = qty.target.value
    this.productListId = productListId
    if (this.qty.length == 1 && qty.keyCode != 8) {
      return false;
    }
  }

  searchKey(data: string) {
    this.searchText = data;
    this.search();
  }

  search() {
    this.filteredProducts = this.searchText === "" ? this.food_listing_response : this.food_listing_response.filter((element) => {
      return element.name.toLowerCase().includes(this.searchText.toLowerCase());
    });
  }

  openShopSigninPopup(modal) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'shop_signin_pop' });

    this.shop_signin_form = this.fb.group({
      // name: ["", [Validators.required]],
      phone_number: ["", [Validators.required, Validators.pattern('^[0-9]*$'), Validators.minLength(8), Validators.maxLength(8)]],
      // email: ["", [Validators.required]]
    });
  }

  shop_sign_in() {
    this.local.removeData();
    const data = this.local.getUser();
    if (data) {
      this.local.removeAdminData();
    }

    this.submitted = true;
    if (this.shop_signin_form.invalid) {
      return;
    }

    const formData = new FormData();
    formData.append('adminId', this.encrypted_client_id);
    // formData.append('name', this.shopSigninV.name.value);
    // formData.append('email', this.shopSigninV.email.value);
    formData.append('phoneNumber', this.shopSigninV.phone_number.value);

    this.auth.login_signup_new_customer(formData).subscribe((response: any) => {
      this.isLogin = 1;
      this.toastr.success(response.message);
      this.local.saveLoginUserData(response.body);
      this.ngOnInit();
      this.router.navigate([`/mobile/${response.body.adminId}`]);
      this.submitted = false;
      this.shop_signin_form.reset();
      this.modalService.dismissAll();
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }

      if (e.error.status == 401 || e.status == 401) {
        this.isLogin = 0;
        this.local.logout();
        this.router.navigate([`/mobile/${this.encrypted_client_id}`])
      }
    });
  }

  openShopSignoutPopup(modal) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'shop_signin_pop' });
  }

  openMemberLinkPopup(modal) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'member_link_pop' });

    // create referral link
    const urlParams = `referral_${this.client_id}_${this.appUserId}`;
    const urlParamsEnc = CryptoJS.AES.encrypt(urlParams, 'shop-web-links').toString();
    const urlParamsEncUrl = encodeURIComponent(urlParamsEnc);
    const urlOrigin = `${this.window.origin}/#/mobile/${urlParamsEncUrl}`;
    this.referralLink = urlOrigin;
  }

  copyReferralLink() {
    this.clipboard.copy(this.referralLink);
    this.toastr.success("Referral Link Copied");
  }

  shopLogout() {
    this.isLogin = 0;
    this.local.removeData();
    this.local.removeAdminData();
    this.modalDismissAll();
  }

  updateCartRemarks(value, cartId) {
    if (value.trim().length > 0 && value.trim().length <= 250) {
      let formData = new FormData;
      formData.append("value", value);
      formData.append("cartId", cartId);

      if (this.isLogin == 1) {
        this.auth.add_cart_remarks(formData).subscribe((response: any) => {

        }, (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }

          if (e.error.status == 401 || e.status == 401) {
            this.isLogin = 0;
            this.local.logout();
            this.router.navigate([`/mobile/${this.encrypted_client_id}`])
          }
        });
      } else {
        this.toastr.error("Please Login First!")
        // this.auth.add_cart_remarks_without_login(formData).subscribe((response: any) => {

        // }, (e) => {
        //   if (e.status == 400) {
        //     this.toastr.error(e.error.message);
        //   }

        //   if (e.error.status == 401 || e.status == 401) {
        //     this.isLogin = 0;
        //     this.local.logout();
        //     this.router.navigate([`/mobile/${this.encrypted_client_id}`])
        //   }
        // });
      }
    }
  }
  getProductReviews(foodId) {
    this.auth.get_product_reviews({ foodId }).subscribe(
      (response: any) => {
        this.reviews_list = response.body
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  getActiveVouchers() {
    this.auth.getActiveVoucher(this.appUserId.toString(), this.appShopId.toString()).subscribe((res) => {
      this.activateVoucherList = res['body']
    })
  }

  configSlider(config) {
    config.interval = 5000;
    config.wrap = false;
    config.keyboard = true;
    config.pauseOnHover = true;
  }

  @ViewChild('myModal') myModal: any;
  openModal(voucher) {
    this.modalDismissAll()
    this.selectedVoucher = voucher
    this.modalRef = this.modalService.open(this.myModal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'Qr-scanner-modal' });
  }



  @ViewChild('infoModal') infoModal: any;
  openInfoModal() {
    this.modalDismissAll()
    this.modalRef = this.modalService.open(this.infoModal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'Qr-scanner-modal' });
  }




  getMobile() {
    if (this.appUserId) {
      this.auth.get_shop_profile_data(this.appUserId).subscribe((res: any) => {
        this.w_phone_number = res?.body?.w_phone_number;
        this.shop_banner = res?.body?.shop_banner;
        this.shop_description = res?.body?.shop_description;
      });
    }
  }


  getCurrentDateTime(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }







  getBookingTime() {
    this.auth.getBookingById({ productId: this.edit_product_id }).subscribe(
      (response: any) => {
        this.userProductBooking = response.body[0].bookingTime


      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );



  }

  addBooking() {
    if (this.edit_product_id != '') {
      this.auth.addBooking({ bookingTime: this.formattedDateTime, productId: this.edit_product_id }).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.productId = ''
          this.modalService2.dismissAll();
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
    } else {
      this.toastr.error("product id is required");
    }
  }

  showFormattedDateTime() {
    const dateString = `${this.model.year}-${this.formatNumber(
      this.model.month
    )}-${this.formatNumber(this.model.day)}`;
    const timeString = `${this.formatNumber(
      this.time.hour
    )}:${this.formatNumber(this.time.minute)}`;
    this.formattedDateTime = `${dateString}T${timeString}`;
  }

  private formatNumber(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }



  isDisabled = (date: NgbDateStruct) => {
    return this.disabledDates.some(d =>
      date.year === d.year && date.month === d.month && date.day === d.day
    );
  }
}
